﻿import {
    openIframeModal,
    closeIframeModal,
    isIframeModalOpen
} from "./modal.js";

const Tv = (globalThis.Tv = globalThis.Tv || {});

Tv.global = {
    cookie: null,
}

Tv.actions = {
    getChannelList: function () {
        //Check if menu is open.
        var menu = document.querySelector(".menu-button");
        if (menu.nextSibling.classList.contains("expanded")) {
            menu.click();
        }

        var channelContainer = document.querySelector(".ajax-channels");

        //Check if channels exists
        if (channelContainer !== null) {
            channelContainer.classList.toggle("toggle");
        } else {
            var url = "/ajax/listtvchannels";
            var callback = Tv.helpers.printChannelList;
            Tv.helpers.makeRequest(url, callback, "POST");
        }
    },

    openLinksInModal: function (selector) {
        if (Tv.actions.modalLinksInitialized) {
            return;
        }

        Tv.actions.modalLinksInitialized = true;

        document.addEventListener("click", function (event) {
            const link = event.target.closest(selector);

            if (!link) {
                return;
            }

            if (
                event.defaultPrevented ||
                event.button !== 0 ||
                event.ctrlKey ||
                event.metaKey ||
                event.shiftKey ||
                event.altKey
            ) {
                return;
            }

            event.preventDefault();

            openIframeModal(link.href);
        });

        window.addEventListener("popstate", function () {
            if (isIframeModalOpen()) {
                closeIframeModal(false);
            }
        });
    },
    insertGoogleAds: function () {
        if (!Object.prototype.hasOwnProperty.call(Tv.global.cookie, "gdprInfoBox")) return;

        const elements = document.querySelectorAll('ins.adsbygoogle');
        if (!elements.length) return;

        let googleScriptBlocked = false;

        let script = document.getElementById('google-adsense-script');
        if (!script) {
            script = document.createElement('script');
            script.id = 'google-adsense-script';
            script.src = "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-4205445155249038";
            script.setAttribute("crossorigin", "anonymous");
            script.onerror = function () {
                console.log("⚠️ Google AdSense-skriptet blockerades av webbläsaren.");
                googleScriptBlocked = true;
            };
            script.async = true;
            document.head.appendChild(script);
        }

        const triggerAzerionFallback = (element) => {
            const div = document.createElement('div');
            div.setAttribute('data-type', '_mgwidget');
            div.setAttribute('data-widget-id', "1907152");
            element.parentNode.replaceChild(div, element);
            Tv.actions.insertAzerionAds();
        };

        elements.forEach((element) => {
            if (googleScriptBlocked) {
                triggerAzerionFallback(element);
                return;
            }

            if (element.getAttribute('data-ad-status') === 'unfilled') {
                triggerAzerionFallback(element);
                return;
            }

            if (element.getAttribute('data-ad-status') === 'filled') return;

            let observer;
            let timeoutId;

            const handleGoogleFailure = (reason) => {
                clearTimeout(timeoutId);
                if (observer) observer.disconnect();

                if (element.getAttribute('data-ad-status') === 'filled') return;

                console.log(`🔄 Byter till Azerion. Orsak: ${reason}`);
                triggerAzerionFallback(element);
            };

            // Ger Chrome 3 sekunder på sig att svara innan timeout slår till
            timeoutId = setTimeout(() => {
                handleGoogleFailure("Timeout (3 sekunder passerade)");
            }, 2500);

            // Lyssna BARA på ändringar i 'data-ad-status' för att undvika falska triggningar i Chrome
            observer = new MutationObserver(() => {
                const currentStatus = element.getAttribute('data-ad-status');
                console.log(`👀 MutationObserver upptäckte statusändring: "${currentStatus}"`);

                if (currentStatus === 'unfilled') {
                    handleGoogleFailure("Google svarade explicit 'unfilled'");
                } else if (currentStatus === 'filled') {
                    console.log("🎉 Google lyckades fylla annonsen! Avbryter fallback.");
                    clearTimeout(timeoutId);
                    observer.disconnect();
                }
            });

            observer.observe(element, { attributes: true, attributeFilter: ['data-ad-status'] });

            // Tryck igång Google direkt utan IntersectionObserver-fördröjning
            window.adsbygoogle = window.adsbygoogle || [];
            window.adsbygoogle.push({});
        });
    },


    insertAzerionAds: function () {
        const hasAcceptedGdpr = Object.prototype.hasOwnProperty.call(
            Tv.global.cookie,
            "gdprInfoBox"
        );

        if (!hasAcceptedGdpr) return;

        const element = document.querySelector('div[data-type="_mgwidget"]');
        if (!element) return;

        const callback = () => {
            const scriptId = "azerion-ads-script";
            const scriptUrl = "https://jsc.native.azerion.com/site/1022560.js";

            const triggerAdLoad = () => {
                window._mgq = window._mgq || [];
                window._mgq.push(["_mgc.load"]);

                setTimeout(() => {
                    Tv.actions.checkAzerionAdsLoad(element);
                    Tv.helpers.resizeSingleShowIframe();
                }, 1500);
            };

            let script = document.getElementById(scriptId);

            if (script) {
                if (script.dataset.loaded === "true") {
                    triggerAdLoad();
                } else {
                    script.addEventListener("load", triggerAdLoad, {
                        once: true
                    });
                }

                return;
            }

            script = document.createElement("script");
            script.src = scriptUrl;
            script.async = true;
            script.id = scriptId;

            script.addEventListener(
                "load",
                () => {
                    script.dataset.loaded = "true";
                    triggerAdLoad();
                },
                { once: true }
            );

            script.addEventListener(
                "error",
                () => {
                    console.error("Failed to load Azerion ads script.");
                    Tv.actions.checkAzerionAdsLoad(element);
                    Tv.helpers.resizeSingleShowIframe();
                },
                { once: true }
            );

            document.head.appendChild(script);
        };

        Tv.helpers.setIntersectionObserver(element, callback, 50);
    },

    checkAzerionAdsLoad(element) {
        const shadow = element?.shadowRoot;
        if (!shadow) return;

        const content = shadow.firstElementChild;
        if (!content) return;

        if (!content || content.getBoundingClientRect().height >= 10) {
            return;
        }

        var ifr = parent.document.getElementById("tvFrame");
        if (!ifr) {
            Tv.actions.createAndInsertGoogleAdFromFallback(element);
            return;
        }
        Math.random() < 0.5 ? Tv.actions.insertAdtractionAd(element, "random", true) : Tv.actions.createAndInsertGoogleAdFromFallback(element);   
    },

    createAndInsertGoogleAdFromFallback(element) {
        if (document.getElementById('google-insert-ad')) {
            return;
        }
        const insTag = document.createElement('ins');
        insTag.className = 'adsbygoogle';
        insTag.style.display = 'block';
        insTag.setAttribute('id', 'google-insert-ad');
        insTag.setAttribute('data-ad-client', 'ca-pub-4205445155249038');
        insTag.setAttribute('data-ad-slot', '8285165181');
        insTag.setAttribute('data-ad-format', 'auto');
        insTag.setAttribute('data-full-width-responsive', 'false');
        element.insertAdjacentElement('afterend', insTag);
        element.remove();

        let script = document.getElementById('google-adsense-script');
        if (!script) {
            script = document.createElement('script');
            script.id = 'google-adsense-script';
            script.src = "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-4205445155249038";
            script.setAttribute("crossorigin", "anonymous");
            script.async = true;
            document.head.appendChild(script);
        }

        window.adsbygoogle = window.adsbygoogle || [];
        window.adsbygoogle.push({});
    },

    insertAdtractionAd: function (element, id = "random", useAdFallback = false) {

        if (element == null) {
            return;
        }
        var adtractionAds = [
            {
                //"Name": "tv4-play-se-tv4-play-700x500",
                "Id": "tv4-play-se",
                "LinkUrl": "https://to.tv4play.se/t/t?a=1827552943&as=1653700919&t=2&tk=1",
                "ImageUrl": "https://track.adtraction.com/t/t?a=1827552943&as=1653700919&t=1&tk=1&i=1",
                "ImageSrc": "/assets/img/ads/tv4-play-se-tv4-play-700x500.jpg",
                "Width": "700",
                "Height": "500"                
            },
            {
                //"Name": "viaplay-se-champions-league-2025-2026",
                "Id": "tv4-play-se-sport",
                "LinkUrl": "https://to.tv4play.se/t/t?a=1948999804&as=1653700919&t=2&tk=1",
                "ImageUrl": "https://track.adtraction.com/t/t?a=1948999804&as=1653700919&t=1&tk=1&i=1",
                "ImageSrc": "/assets/img/ads/tv4-play-se-tv4-play-sport-462x577.png",
                "Width": "462",
                "Height": "577"
            },
            {
                //"Name": "enklare-320x320",
                "Id": "enklare",
                "LinkUrl": "https://do.enklare.se/t/t?a=1552774578&as=1653700919&t=2&tk=1",
                "ImageUrl": "https://track.adtraction.com/t/t?a=1552774578&as=1653700919&t=1&tk=1&i=1",
                "ImageSrc": "/assets/img/ads/enklare-320x320.png",
                "Width": "320",
                "Height": "320"
            },
            {
                //"Name": "allente-se-hockey-vm-2025-700x500",
                "Id": "allente-se",
                "LinkUrl": "https://at.shop.allente.se/t/t?a=1975158487&as=1653700919&t=2&tk=1",
                "ImageUrl": "https://track.adtraction.com/t/t?a=1975158487&as=1653700919&t=1&tk=1&i=1",
                "ImageSrc": "/assets/img/ads/allente-se-hockey-vm-2025-700x500.jpg",
                "Width": "700",
                "Height": "500"
            },
            {
                //"Name": "klara-lan-se-400x400",
                "Id": "klara-lan-se",
                "LinkUrl": "https://go.adt267.com/t/t?a=1187152926&as=1653700919&t=2&tk=1",
                "ImageUrl": "https://track.adtraction.com/t/t?a=1187152926&as=1653700919&t=1&tk=1&i=1",
                "ImageSrc": "/assets/img/ads/klara-lan-se-400x400.jpg",
                "Width": "400",
                "Height": "400"
            },
            {
                //"Name": "nextstory-se-400x400",
                "Id": "nextory-se",
                "LinkUrl": "https://pin.nextory.se/t/t?a=1107191653&as=1653700919&t=2&tk=1",
                "ImageUrl": "https://track.adtraction.com/t/t?a=1107191653&as=1653700919&t=1&tk=1&i=1",
                "ImageSrc": "/assets/img/ads/nextory-se-400x400.jpg",
                "Width": "400",
                "Height": "400"
            },
            {
                //"Name": "trippel-se 400x400",
                "Id": "trippel-se",
                "LinkUrl": "https://do.trippel.se/t/t?a=2001749586&as=1653700919&t=2&tk=1",
                "ImageUrl": "https://track.adtraction.com/t/t?a=2001749586&as=1653700919&t=1&tk=1&i=1",
                "ImageSrc": "/assets/img/ads/trippel-se-962x541.png",
                "Width": "962",
                "Height": "541"
            },
            {
                //"Name": "HelloFresh SE 400x400",
                "Id": "hellofresh-se",
                "LinkUrl": "https://go.adt291.com/t/t?a=1559684544&as=1653700919&t=2&tk=1",
                "ImageUrl": "https://track.adtraction.com/t/t?a=1559684544&as=1653700919&t=1&tk=1&i=1",
                "ImageSrc": "/assets/img/ads/hellofresh-se-600-300.jpg",
                "Width": "600",
                "Height": "300"
            },
            {
                //"Name": "hemkop-se 400x400",
                "Id": "hemkop-se",
                "LinkUrl": "https://go.adt228.com/t/t?a=1515835887&as=1653700919&t=2&tk=1",
                "ImageUrl": "https://track.adtraction.com/t/t?a=1515835887&as=1653700919&t=1&tk=1&i=1",
                "ImageSrc": "/assets/img/ads/hemkop-400x400.jpg",
                "Width": "400",
                "Height": "400"
            },
            {
                //"Name": "incclub 400x400",
                "Id": "incclub-se",
                "LinkUrl": "https://at.inkclub.com/t/t?a=1201499270&as=1653700919&t=2&tk=1",
                "ImageUrl": "https://track.adtraction.com/t/t?a=1201499270&as=1653700919&t=1&tk=1&i=1",
                "ImageSrc": "/assets/img/ads/incclub-se-400x400.jpg",
                "Width": "400",
                "Height": "400"
            },
            {
                //"Name": "tv4-allsvenskan-2026-500x400",
                "Id": "incclub-se",
                "LinkUrl": "https://to.tv4play.se/t/t?a=2065066191&as=1653700919&t=2&tk=1",
                "ImageUrl": "https://track.adtraction.com/t/t?a=2065066191&as=1653700919&t=1&tk=1&i=1",
                "ImageSrc": "/assets/img/ads/tv4-allsvenskan-2026-500x400.jpg",
                "Width": "500",
                "Height": "400"
            },
            {
                //"Name": "skyshowtime-trion-may-2026-500x400",
                "Id": "incclub-se",
                "LinkUrl": "https://go.adt246.net/t/t?a=2090968186&as=1653700919&t=2&tk=1",
                "ImageUrl": "https://track.adtraction.com/t/t?a=2090968186&as=1653700919&t=1&tk=1&i=1",
                "ImageSrc": "/assets/img/ads/skyshowtime-trion-may-2026-500x400.jpg",
                "Width": "500",
                "Height": "400"
            }
        ];

        var ad;
        if (id == "random") {
            ad = adtractionAds[Math.floor(Math.random() * adtractionAds.length)];
        } else {
            ad = adtractionAds.find(ad => ad.Id === id);
        }

        var html = `<a href="${ad.LinkUrl}" rel="noopener noreferrer" target="_blank"><img src="${ad.ImageSrc}" width="${ad.Width}" height="${ad.Height}" alt="Annonsbild" class="fade-img" onload="this.classList.add('loaded')"></a>`;

        if (useAdFallback) {
            const div = document.createElement('div');
            div.className = 'ad-traction space-t-b';
            div.innerHTML = html;
            element.before(div);
            element.remove();
            return;
        }

        var callback = function () {
            setTimeout(() => {
                element.innerHTML = html;
            }, 1);
        };
        Tv.helpers.setIntersectionObserver(element, callback, 50);
    },

    saveChannels: function(name) {
        var channels = [];
        var selectedChannels = document.querySelectorAll(".switch input");
        [].forEach.call(selectedChannels,
            function(channel) {
                if (!channel.checked) {
                    channels.push(channel.id);
                }
            });

        Tv.helpers.saveCookie(name, channels);
    },

    saveSortedChannels: function(name) {
        var channels = [];
        var sortedChannels = document.querySelectorAll("#channelList li");
        [].forEach.call(sortedChannels,
            function(channel) {
                channels.push(channel.id);
            });
        Tv.helpers.saveCookie(name, channels);
    },

    deleteChannels: function (channels) {
        if (channels === undefined) {
            return;
        }
        [].forEach.call(channels,
            function (channelId) {
                try {
                    var channel = document.querySelector("#" + channelId);
                    console.log("channel was removed" + channelId);
                    channel.parentNode.removeChild(channel);
                } catch (e) {
                    console.log("Channel not removed " + channelId);
                } 
            });
    },

    sortChannels: function (channels, container) {

        if (!Array.isArray(channels) || !container) {
            return;
        }

        var allChannels = Array.from(
            container.querySelectorAll(":scope > .box")
        );

        var channelsById = new Map(
            allChannels.map(function (channel) {
                return [channel.id, channel];
            })
        );

        var fragment = document.createDocumentFragment();

        // Add saved channels in the user's chosen order.
        channels.forEach(function (channelId) {
            var channel = channelsById.get(channelId);

            if (channel) {
                fragment.appendChild(channel);
                channelsById.delete(channelId);
            }
        });

        // Add any new or missing channels afterward.
        channelsById.forEach(function (channel) {
            fragment.appendChild(channel);
        });

        container.appendChild(fragment);
    },

    handleUserChannelSelection: function (currentCookie) {
    var loadMoreButton = document.querySelector("[data-load-channels]");

    if (!loadMoreButton || currentCookie === null) {
        return;
    }

    var page = document.body.getAttribute("data-page");

    if (!page) {
        return;
    }

    var collectionName = page.split(" ")[1];

    if (!collectionName) {
        return;
    }

    var collectionNameSort = collectionName + "Sorted";
    var userHasRemovedChannels = Object.prototype.hasOwnProperty.call(
        currentCookie,
        collectionName
    );
    var userHasSortedChannels = Object.prototype.hasOwnProperty.call(
        currentCookie,
        collectionNameSort
    );

    if (!userHasRemovedChannels && !userHasSortedChannels) {
        return;
    }

    Tv.helpers.loadMoreChannels(loadMoreButton, function (data) {
        var template = document.createElement("template");
        template.innerHTML = data.trim();

        loadMoreButton.parentNode.insertBefore(
            template.content,
            loadMoreButton
        );

        loadMoreButton.remove();

        if (userHasRemovedChannels) {
            Tv.actions.deleteChannels(
                currentCookie[collectionName]
            );
        }

        if (userHasSortedChannels) {
            Tv.actions.sortChannels(
                currentCookie[collectionNameSort],
                document.querySelector(".flex-grid")
            );
        }
    });
    },

    initLoadMoreChannelsButton: function () {
        var loadMoreButton = document.querySelector("[data-load-channels]");

        if (!loadMoreButton) {
            return;
        }

        loadMoreButton.addEventListener("click", function (event) {
            event.preventDefault();

            Tv.helpers.loadMoreChannels(this);
        });
    },

    initToggleActions: function () {
        document.querySelectorAll("[data-toggle-button]").forEach(function (button) {
            var list = button.previousElementSibling;
            var toggleItems = Array.from(list.querySelectorAll(".toggle"));
            var label = button.querySelector("[data-toggle-label]");
            var icon = button.querySelector("i");

            button.addEventListener("click", function (e) {
                e.preventDefault();

                var isExpanded = button.getAttribute("aria-expanded") === "true";

                toggleItems.forEach(function (item) {
                    item.classList.toggle("toggle", isExpanded);
                });

                button.setAttribute("aria-expanded", !isExpanded);
                label.textContent = isExpanded ? button.dataset.showText : button.dataset.hideText;

                if (icon) {
                    icon.classList.toggle("fa-angle-down", isExpanded);
                    icon.classList.toggle("fa-angle-up", !isExpanded);
                }
            });
        });
    },

    hideRedundantShowMoreLinks: function () {
        const footerLinks = document.querySelectorAll("li.footer");
        [].forEach.call(footerLinks,
            function (link) {
                var prev = link.previousSibling;
                if (prev.offsetParent === null) {
                    link.querySelector("span").style.cssText = "display:block";
                } 
            });
    },

    setUpWeekdayNavigation: function () {
        var navigation = document.querySelector(".week-day-navigation");
        if (!navigation) return;

        var toggle = navigation.querySelector(".day-menu-toggle");
        if (!toggle) return;
        navigation.addEventListener("click", function () {
            var isOpen = navigation.classList.toggle("selected");
            toggle.setAttribute("aria-expanded", isOpen);
        });
    },

    toggleChannelSwitchBasedOnCookie: function (collectionName) {
        var currentCookie = Tv.global.cookie;
        if (currentCookie === null) {
            return;
        }

        if (!currentCookie.hasOwnProperty(collectionName)) {
            return;
        }

        var userToggledChannels = currentCookie[collectionName];
        [].forEach.call(userToggledChannels,
            function (channel) {
                var c = document.querySelector("#" + channel);
                if (c) {
                    c.checked = false;
                }
            });
        Tv.actions.saveChannels(collectionName);
    },

    showTrailer: function () {
        var trailerLinks = document.querySelectorAll(".play-button");

        [].forEach.call(trailerLinks, function (link) {
            link.addEventListener("click", function (e) {

                var trailerUrl = this.getAttribute("data-youtubeurl");

                if (!trailerUrl) {
                    return;
                }

                var youTubeId = Tv.helpers.extractYoutubeId(trailerUrl);

                if (!youTubeId) {
                    return;
                }

                var youTubeEmbedUrl =
                    "https://www.youtube.com/embed/" +
                    youTubeId +
                    "?autoplay=1&mute=1";

                var overlay = document.createElement("div");
                overlay.className = "trailer-fullscreen";

                overlay.innerHTML =
                    "<button type=\"button\" class=\"trailer-close\" aria-label=\"Stäng trailer\">&times;</button>" +
                    "<iframe src=\"" + youTubeEmbedUrl + "\" " +
                    "frameborder=\"0\" " +
                    "allow=\"autoplay; encrypted-media; picture-in-picture; fullscreen\" " +
                    "allowfullscreen " +
                    "class=\"trailer-frame\"></iframe>";

                document.body.appendChild(overlay);
                document.body.classList.add("trailer-open");

                var closeTrailer = function () {
                    if (overlay.parentNode) {
                        overlay.parentNode.removeChild(overlay);
                    }

                    document.body.classList.remove("trailer-open");
                    document.removeEventListener("keydown", onKeyDown);
                };

                var onKeyDown = function (e) {
                    if (e.key === "Escape") {
                        closeTrailer();
                    }
                };

                overlay.querySelector(".trailer-close")
                    .addEventListener("click", closeTrailer);

                overlay.addEventListener("click", function (e) {
                    if (e.target === overlay) {
                        closeTrailer();
                    }
                });

                document.addEventListener("keydown", onKeyDown);
            });
        });
    }
};

Tv.helpers = {

    setIntersectionObserver: function (element, callback, distance) {

        if (!element) {
            return false;
        }

        if (!('IntersectionObserver' in window)) {
            console.log("No support for IntersectionObserver");
            return false;
        }

        var options = {
            root: null,
            rootMargin: distance + "px 0px",
            threshold: 0
        };

        var elementObserver = new IntersectionObserver(function (entries) {
            var entry = entries[0];

            if (!entry || !entry.isIntersecting) {
                return;
            }

            elementObserver.unobserve(element);
            callback();
        }, options);

        elementObserver.observe(element);

        return elementObserver;
    },

    handleShowMoreText: function () {
        var toggleList = document.querySelectorAll(".show-more-text");
        [].forEach.call(toggleList,
            function (toggle) {
                toggle.addEventListener("click",
                    function () {
                        this.classList.toggle("expanded");
                    });
            });
    },

    handleToggleOfPreviousShows: function (button, containerToToggleArr, storeCookie) {
       var showCompleteScheduleButton = button.querySelector("i.fa");
        if (button.getAttribute("data-showprevious") === "true") {
            showCompleteScheduleButton.className = "fa fa-toggle-off";
            if (storeCookie) {
                Tv.helpers.saveCookie("showCompleteScheduleOnStartPage", null, "delete");
            }
            button.setAttribute("data-showprevious", false);
            button.setAttribute("aria-pressed", false);
            [].forEach.call(containerToToggleArr,
                function (container) {
                    container.classList.remove("expanded");
                });

        } else {
            showCompleteScheduleButton.className = "fa fa-toggle-on";
            if (storeCookie) {
                Tv.helpers.saveCookie("showCompleteScheduleOnStartPage", true);
            }
            button.setAttribute("data-showprevious", true);
            button.setAttribute("aria-pressed", true);
            [].forEach.call(containerToToggleArr,
                function (container) {
                    container.classList.add("expanded");
                });
        }
    },

     initGenreFilter: function(listSelector, buttonSelector) {
        var list = document.querySelector(listSelector);
        if (!list) return;

        var buttons = document.querySelectorAll(buttonSelector);

        buttons.forEach(function (button) {
            button.addEventListener("click", function () {
                var selectedGenres = button.dataset.genre.split(",").map(function (genre) { return genre.trim(); });
                var excludedGenres = button.dataset.excludeGenre ? button.dataset.excludeGenre.split(",").map(function (genre) { return genre.trim(); }) : [];

                buttons.forEach(function (item) { item.classList.remove("active"); });
                button.classList.add("active");

                list.querySelectorAll("[data-genres]").forEach(function (item) {
                    var genres = item.dataset.genres.split(",").map(function (genre) { return genre.trim(); });
                    var hasMatchingGenre = selectedGenres.some(function (genre) { return genres.includes(genre); });
                    var hasExcludedGenre = excludedGenres.some(function (genre) { return genres.includes(genre); });

                    item.hidden = !selectedGenres.includes("all") && (!hasMatchingGenre || hasExcludedGenre);
                });
            });
        });
    },

    highlightMenuLink: function (index) {
        var menuLinks = document.querySelectorAll(".menu a");
        menuLinks[index].classList.add("selected");
        menuLinks[index].setAttribute("aria-current", "page");
    },
    
    readCookie: function () {
        var cookie = localStorage.getItem("tvtabla");
        if (cookie) {
            return JSON.parse(cookie);
        }
        return {};
    },

    saveCookie: function(prop, value, action) {
        var currentCookie = Tv.helpers.readCookie();
      
        if (typeof action === "undefined") {
            action = "save";
        }

        if (action === "delete") {
            delete currentCookie[prop];
        } else {
            currentCookie[prop] = value;
        }
        localStorage.setItem("tvtabla", JSON.stringify(currentCookie));
        Tv.global.cookie = currentCookie;
    },

    loadMoreChannels: function (button, callback) {
        if (!button) {
            return;
        }

        var day = button.getAttribute("data-day") || ""
        var isRadio = button.getAttribute("data-load-channels") === "radio";

        var url = isRadio
            ? "/radio/loadextrachannels?day=" + day
            : "/loadextrachannels?day=" + day;

        if (typeof callback !== "function") {
            callback = function (data) {
                var template = document.createElement("template");
                template.innerHTML = data.trim();

                button.parentNode.insertBefore(
                    template.content,
                    button
                );

                button.remove();
            };
        }

        Tv.helpers.makeRequest(url, callback, "POST", 6000);
    },


    resizeSingleShowIframe: function () {
        var ifr = parent.document.getElementById("tvFrame");
        if (!ifr) {
            return false;
        }

        var c = document.querySelector(".show-container");
        if (!c) {
            return false;
        }
        h = c.offsetHeight;
        ifr.style.minHeight = (h) + "px";
        return true;
    },

    extractYoutubeId: function(url) {
        const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
        const match = url.match(regExp);
        return (match && match[7].length === 11) ? match[7] : false;
    },


    userHasChoosenToShowCompleteSchedule: function (currentCookie) {
        const collectionName = "showCompleteScheduleOnStartPage";
        if (currentCookie === null) {
            return false;
        }

        if (currentCookie.hasOwnProperty(collectionName)) {
            return true;
        }
        return false;
    },

    printChannelList: function(data) {
        var channelContainer = document.createElement("div");
        channelContainer.className = "ajax-channels space flex-grid";
        channelContainer.innerHTML = data;
        
        var header = document.querySelector("header");
        header.parentNode.insertBefore(channelContainer, header.nextSibling);
    },

    makeRequest: function (url, callback, method, timeOutInMs) {
        try {
            timeOutInMs = timeOutInMs || 5000;
            var xmlhttp = new XMLHttpRequest();
            xmlhttp.onreadystatechange = function () {
                if (this.readyState === 4 && this.status === 200) {
                    var result = this.responseText;
                    if (callback === null) {
                        console.log(result);
                        return;
                    } else {
                        callback(result);
                    }
                }
            };
            xmlhttp.open(method, url, true);
            xmlhttp.timeout = timeOutInMs;
            xmlhttp.send();
        } catch (error) {
            console.log(error);
        }
    },

    replaceClass: function (classList, findClass, replaceWithClass) {
        var newClassList = [];
        [].forEach.call(classList,
            function(item) {
                if (item === findClass) {
                    newClassList.push(replaceWithClass);
                } else {
                    newClassList.push(item);
                }
            });

        return newClassList.join(" ");
    },

    handleInactivity: function (minutes) {
        var time;
        window.addEventListener("load", resetTimer, true);

        var events = ["mousedown", "keypress", "touchstart"];
        events.forEach(function (name) {
            document.addEventListener(name, resetTimer, true);
        });

        function logout() {
            console.log("reload");
            console.log(Date.now());
            document.location.reload();
        }

        function resetTimer() {
            clearTimeout(time);
            time = setTimeout(logout, (60 * 1000) * minutes);
        }
    },

    getActorImages: function () {
        var actors = document.querySelectorAll("[data-actor]");
        [].forEach.call(actors,
            function (actor) {
                var name = actor.getAttribute("data-actor");
                var url = "https://sv.wikipedia.org/w/api.php?action=query&format=json&formatversion=2&prop=pageimages|pageterms&pithumbsize=174&redirects=1&origin=*&titles=" + encodeURIComponent(name);
                var callback = function (response) {

                    var json;
                    try {
                        json = JSON.parse(response);
                    } catch (e) {
                        json = null;
                    }
                    var page = json && json.query && json.query.pages && json.query.pages[0];
                    var thumb = page && page.thumbnail ? page.thumbnail.source : null;
                    if (thumb !== null) {
                        var container = actor.querySelector(".img-placeholder")
                        container.innerHTML = '<img src="' + thumb + '" title="Foto: Wikipedia" alt="Foto föreställande ' + name + '">';
                    }
                };
                Tv.helpers.makeRequest(url, callback, "get", 1500);
            });
    },

    trackPage: function () {
        var cookie = Tv.global.cookie;
        var hasAcceptedGdpr = cookie.hasOwnProperty("gdprInfoBox");

        if (!hasAcceptedGdpr) {
            return;
        }

        window.dataLayer = window.dataLayer || [];
        function gtag() { dataLayer.push(arguments); }
        gtag('js', new Date());
        gtag('config', 'G-B0P57QHLX0');
    },

    showGdprMessage: function () {
        var hasAcceptedGdpr = Tv.global.cookie.hasOwnProperty("gdprInfoBox");
 
        if (hasAcceptedGdpr) {
            return;
        }

        var message = "Vår <a href=\"/\">TV-tablå</a> använder sig av cookies. Genom att fortsätta använda vår tjänst accepterar du vår <a href=\"/info/dataskyddspolicy/\" class=\"underline\">dataskyddspolicy</a> och användandet av cookies, visning av annonser samt insamling av statistik för att förbättra användarupplevelsen.";
        var infoCookieContainer = document.createElement("div");
        infoCookieContainer.classList.add("cookie-container");
        infoCookieContainer.innerHTML = "<div class=\"page-holder\"><p>" + message + "</p><button class=\"buttons blue space-m\" onclick=\"Tv.helpers.acceptGdprMessage(true);\">Jag godkänner</button></div>";
        document.querySelector("body").appendChild(infoCookieContainer);
    },
    acceptGdprMessage: function (status) {
        var cookieContainer = document.querySelector(".cookie-container");
        var infoContainer = document.querySelector(".info-box");

        if (cookieContainer) {
            cookieContainer.remove();
        }

        if (infoContainer) {
            infoContainer.remove();
        }

        Tv.helpers.saveCookie("gdprInfoBox", status, "save");
    }
};

Tv.autocomplete = {
    allowedChars: new RegExp(/^[a-zA-Z\s]+$/),

    mapData: function(response) {
        var data = JSON.parse(response);
        var programs = data[0].Value;
        var channels = data[1].Value;
        var conts = programs.map(function (n) { return { label: n, group: "Program" };});
        var items = channels.map(function (n) { return { label: n, group: "Kanaler" }; }).concat(conts);
        Tv.autocomplete.renderAutoComplete(items);
    },

    insertSearchButtonOnMenu: function () {
        var container = document.querySelector(".search-button");
        var searchLink = container.querySelector("a");
        
        if (container.classList.contains("expanded")) {
            container.querySelector(".search-container").style.display = "none";
            searchLink.style.display = "block";
            container.classList.toggle("expanded");
            return false;
        }
       
        searchLink.style.display = "none";

        if (container.querySelector(".search-container")) {
            container.querySelector(".search-container").style.display = "";
            container.classList.add("expanded");
            container.querySelector("input").focus();
            return;
        }
        
        var searchContainer = document.createElement("div");
        searchContainer.setAttribute("class", "search-container");

        var input = document.createElement("input");
        input.setAttribute("id", "autocomplete-searchbox");
        input.setAttribute("type", "text");
        input.setAttribute("placeholder", "Sök");

        var clearButton = document.createElement("i");
        clearButton.setAttribute("class", "clear-button fa fa-times-circle");
        clearButton.addEventListener("click", function () {
            Tv.autocomplete.insertSearchButtonOnMenu();
        });

        searchContainer.appendChild(input);
        searchContainer.appendChild(clearButton);

        container.appendChild(searchContainer);
        input.focus();
        container.classList.toggle("expanded");
    },

    checkAllowedChars: function (value) {
        return this.allowedChars.test(value);
    },
    
    getData: function() {
       Tv.helpers.makeRequest("/ajax/searchprograms", Tv.autocomplete.mapData, "GET", 7000);
    },

    loadScript: function() {
        (function (d, s, id) {
            var js, fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) { return; }
            js = d.createElement(s); js.id = id;
            js.onload = function () {
                Tv.autocomplete.getData();
            };
            js.src = "/assets/v/auto-complete.min.js";
            fjs.parentNode.insertBefore(js, fjs);
        }(document, "script", "channels-programs-autocomplete"));
    },

    renderAutoComplete: function (items) {
        Tv.autocomplete.insertSearchButtonOnMenu();
        autocomplete({
            input: document.getElementById("autocomplete-searchbox"),
            minLength: 1,
            onSelect: function (item, inputfield) {
          var url = "";
                if (item.group === "Kanaler") {
                    url = "/tabla/" + item.label.value +"/";
                } else {
                    url = item.label.value;
                }
                document.location.href = url;
            },
            fetch: function (text, callback) {
                var match = text.toLowerCase();
                callback(items.filter(function (n) {
                    return n.label.label.toLowerCase().indexOf(match) !== -1;
                }));
            },
            render: function (item, value) {
                var itemElement = document.createElement("div");
                if (Tv.autocomplete.checkAllowedChars(value)) {
                    var regex = new RegExp(value, 'gi');
                    
                    var inner = item.label.label.replace(regex, function (match) {
                        return "<strong>" + match + "</strong>";
                    });
                    itemElement.innerHTML = inner;
                } else {
                    itemElement.textContent = item.label.label;
                }
                return itemElement;
            },
            emptyMsg: "Inga program eller kanaler hittades",
            customize: function (input, inputRect, container, maxHeight) {
                if (maxHeight < 100) {
                    container.style.top = "";
                    container.style.bottom = (window.innerHeight - inputRect.bottom + input.offsetHeight) + "px";
                    container.style.maxHeight = "140px";
                }
            }
        });
    },

    init: function () {
        if (document.querySelector(".search-button .search-container")) {
            this.insertSearchButtonOnMenu();
            return;
        }
        this.loadScript();
    }
},

    Tv.movieNotifications = {
        storageKey: "movieNotifications",
        sessionCheckKey: "movieNotificationsChecked",

        getAll: function () {
            try {
                return JSON.parse(
                    localStorage.getItem(this.storageKey)
                ) || [];
            } catch (error) {
                console.log("Could not read movie notifications", error);
                return [];
            }
        },

        saveAll: function (movies) {
            localStorage.setItem(
                this.storageKey,
                JSON.stringify(movies)
            );
        },

        isWatching: function (url) {
            return this.getAll().some(function (movie) {
                return movie.url === url;
            });
        },

        add: function (title, url) {
            var movies = this.getAll();

            var alreadyExists = movies.some(function (movie) {
                return movie.url === url;
            });

            if (alreadyExists) {
                return;
            }

            movies.push({
                title: title,
                url: url
            });

            this.saveAll(movies);

            this.track("movie_notification_add", {
                title: title,
                url: url
            });
        },

        remove: function (url) {
            var movies = this.getAll();

            var movie = movies.find(function (item) {
                return item.url === url;
            });

            movies = movies.filter(function (item) {
                return item.url !== url;
            });

            this.saveAll(movies);

            if (movie) {
                this.track("movie_notification_remove", movie);
            }
        },

    initMoviePage: function () {
        var button = document.querySelector(
            "[data-movie-notification]"
        );

        if (!button) {
            return;
        }

        var title = button.getAttribute("data-movie-title");
        var url = button.getAttribute("data-movie-url");

        if (!title || !url) {
            return;
        }

        /*
         * Om Razor har satt hidden betyder det att filmen
         * redan har kommande TV-sändningar.
         */
        var hideWhenNotWatching = button.hidden;

        /*
         * Om användaren redan bevakar filmen ska knappen
         * visas även om Razor ursprungligen gömde den.
         */
        if (this.isWatching(url)) {
            button.hidden = false;
        }

        this.updateButton(button, url);

        button.addEventListener("click", function (event) {
            event.preventDefault();

            var isWatching =
                Tv.movieNotifications.isWatching(url);

            if (isWatching) {
                Tv.movieNotifications.remove(url);

                /*
                 * Filmen går redan på TV.
                 * När bevakningen tas bort finns ingen anledning
                 * att visa bevakningsknappen längre.
                 */
                if (hideWhenNotWatching) {
                    button.hidden = true;
                    return;
                }
            } else {
                Tv.movieNotifications.add(title, url);
                button.hidden = false;
            }

            Tv.movieNotifications.updateButton(
                button,
                url
            );
        });
    },

        updateButton: function (button, url) {
            var isWatching = this.isWatching(url);

            button.setAttribute(
                "aria-pressed",
                isWatching ? "true" : "false"
            );

            button.classList.toggle(
                "active",
                isWatching
            );

            if (isWatching) {
                button.innerHTML =
                    '✔ Du bevakar filmen';
            } else {
                button.innerHTML =
                    '🔔 Notifiera mig när filmen går på TV';
            }
        },

    check: function () {
            if (
                sessionStorage.getItem(
                    this.sessionCheckKey
                )
            ) {
                return;
            }

            var watchedMovies = this.getAll();

            if (!watchedMovies.length) {
                return;
            }

            /*
             * Markera kontrollen direkt så att vi inte
             * råkar göra flera requests under samma session.
             */
            sessionStorage.setItem(
                this.sessionCheckKey,
                "1"
            );

            Tv.helpers.makeRequest(
                "/ajax/searchprograms",
                function (response) {
                    Tv.movieNotifications.handleSearchResponse(
                        response,
                        watchedMovies
                    );
                },
                "GET",
                7000
            );
        },

        handleSearchResponse: function (
            response,
            watchedMovies
        ) {
            var data;

            try {
                data = JSON.parse(response);
            } catch (error) {
                console.log(
                    "Could not parse search programs",
                    error
                );

                return;
            }

            var programsGroup = data.find(
                function (group) {
                    return group.Key === "programs";
                }
            );

            if (
                !programsGroup ||
                !Array.isArray(programsGroup.Value)
            ) {
                return;
            }

            var programs = programsGroup.Value;

            watchedMovies.forEach(function (movie) {

                var match = programs.find(
                    function (program) {
                        return (
                            program.value &&
                            program.value === movie.url
                        );
                    }
                );

                if (!match) {
                    return;
                }

                Tv.movieNotifications.showNotification(
                    movie,
                    match
                );
            });
        },

        showNotification: function (movie, match) {
            /*
             * Förhindrar samma notifiering från att visas
             * flera gånger under samma session.
             */
            var seenKey =
                "movieNotificationSeen:" +
                movie.url;

            if (
                sessionStorage.getItem(seenKey)
            ) {
                return;
            }

            sessionStorage.setItem(
                seenKey,
                "1"
            );

            var notification =
                document.createElement("div");

            notification.className =
                "movie-notification bshadow";

            var content =
                document.createElement("div");

            content.className =
                "movie-notification__content";

            var heading =
                document.createElement("strong");

            heading.className =
                "movie-notification__title";

            heading.textContent =
                "En film du bevakar går snart på TV";

            var movieTitle =
                document.createElement("a");

            movieTitle.className =
                "movie-notification__movie";

            movieTitle.href = movie.url;

            movieTitle.textContent =
                movie.title;

            movieTitle.addEventListener(
                "click",
                function () {
                    Tv.movieNotifications.track(
                        "movie_notification_click",
                        movie
                    );
                }
            );


            var closeButton =
                document.createElement("button");

            closeButton.type = "button";

            closeButton.className =
                "movie-notification__close";

            closeButton.setAttribute(
                "aria-label",
                "Stäng notifieringen"
            );

            closeButton.innerHTML =
                '<i class="fa red fa-times-circle"></i>';

            closeButton.addEventListener(
                "click",
                function () {
                    notification.remove();
                }
            );

            content.appendChild(heading);
            content.appendChild(movieTitle);

            notification.appendChild(content);
            notification.appendChild(closeButton);

            document.body.appendChild(
                notification
            );

            this.track(
                "movie_notification_match",
                movie
            );
        },

        track: function (eventName, movie) {
            if (
                !Tv.global.cookie ||
                !Object.prototype.hasOwnProperty.call(
                    Tv.global.cookie,
                    "gdprInfoBox"
                )
            ) {
                return;
            }

            window.dataLayer =
                window.dataLayer || [];

            window.dataLayer.push({
                event: eventName,
                movie_title: movie.title || "",
                movie_url: movie.url || ""
            });
        }
    };

Tv.listners = {

    // START PAGE
    startPage: function () {

        var c = Tv.global.cookie;

        Tv.actions.initLoadMoreChannelsButton();

        Tv.actions.handleUserChannelSelection(c);
        
        Tv.actions.hideRedundantShowMoreLinks();

        Tv.actions.setUpWeekdayNavigation();

        //Pop-up
        Tv.actions.openLinksInModal(".box .pop");     

        //Handle toggled schedule
        var userHasToggledShowPreviousSchedule = Tv.helpers.userHasChoosenToShowCompleteSchedule(c);
        var togglePreviousScheduleButton = document.querySelector("[data-showprevious]");
 
        if (userHasToggledShowPreviousSchedule) {
            togglePreviousScheduleButton.setAttribute("data-showprevious", false);
            Tv.helpers.handleToggleOfPreviousShows(
                togglePreviousScheduleButton,
                document.querySelectorAll(".box ol"),
                true
            );
        }

        //Toggle complete schedule
        togglePreviousScheduleButton.addEventListener("click", function() {
            Tv.helpers.handleToggleOfPreviousShows(
                this,
                document.querySelectorAll(".box ol"),
                true
            );
        });

        //Toggle dark/light theme
        var toggleTheme = document.querySelector("[data-set-theme]");

        toggleTheme.addEventListener("click", function () {
            var root = document.documentElement;
            var isDark = root.classList.contains("dark") ||
                (!root.classList.contains("light") && matchMedia("(prefers-color-scheme: dark)").matches);

            root.classList.add("animate");
            root.classList.toggle("dark", !isDark);
            root.classList.toggle("light", isDark);

            localStorage.setItem("theme", isDark ? "light" : "dark");
        });

        //Show complete schedule
        var arrLinks = document.querySelectorAll(".flex-grid .toggle-future");
        [].forEach.call(arrLinks, function (link) {
            link.addEventListener("click",
                function () {
                    var channel = this.parentNode.parentNode;
                    if (channel.classList.contains("expanded")) {
                        channel.classList.remove("expanded");
                    } else {
                        channel.classList.add("expanded");
                    }
                });
        });
        var highlightMenu = document.querySelector("body").getAttribute("data-page");
        Tv.helpers.handleInactivity(11);
        Tv.helpers.highlightMenuLink((highlightMenu.includes("radiochannels") ? 1 : 0));
    },

    // CHANNEL PAGE
    channelPage: function(highlightMenu) {
 
        //Weekday navigation
        Tv.actions.setUpWeekdayNavigation();
        
        //Toggle complete schedule
        var togglePreviousScheduleButton = document.querySelector(".toggle-previous");
        togglePreviousScheduleButton.addEventListener("click", function () {
            Tv.helpers.handleToggleOfPreviousShows(
                this,
                document.querySelectorAll(".schedule-tabla"),
                false
            );
        });

        //Show more of channel description
        Tv.helpers.handleShowMoreText();
        Tv.helpers.handleInactivity(11);
        Tv.helpers.highlightMenuLink(highlightMenu);
    },

    sortChannelsSettingsPage: function() {
        //Remove channels
        const collectionName = document.querySelector("body").getAttribute("data-page").split(" ")[1];
        const collectionNameSort = collectionName + "Sorted";
        const currentCookie = Tv.helpers.readCookie();
        if (currentCookie === null) {
            return false;
        }

        if (currentCookie.hasOwnProperty(collectionName)) {
            Tv.actions.deleteChannels(currentCookie[collectionName]);
        }

        //Sort if cookie exists
        if (currentCookie.hasOwnProperty(collectionNameSort)) {
            var userSelectedChannels = currentCookie[collectionNameSort];
            if (userSelectedChannels !== undefined) {
                Tv.actions.sortChannels(currentCookie[collectionNameSort], document.querySelector("#channelList"));
            }
        }

        document.querySelector(".reset-channels-button").addEventListener("click",
            function () {
                this.className = Tv.helpers.replaceClass(this.classList, "red", "blue");
                Tv.helpers.saveCookie(collectionNameSort, null, "delete");
                setTimeout(function() {
                      document.location.reload();
                    },
                    500);
            });
        
        // Init sortable
        Sortable.create(channelList,
            {
                group: "channelList",
                animation: 100,
                onEnd: function(evt) {
                    Tv.actions.saveSortedChannels(collectionName + "Sorted");
                }
            });
        return false;
    },

    // CHANNEL SETTINGS PAGE
    channelSettings: function () {
        var collectionName = document.querySelector("body").getAttribute("data-page").split(" ")[1];

        Tv.actions.toggleChannelSwitchBasedOnCookie(collectionName);

      
        var toggleList = document.querySelectorAll(".switch");
        [].forEach.call(toggleList,
            function(toggle) {
                toggle.addEventListener("click",
                    function() {
                        Tv.actions.saveChannels(collectionName);
                    });
            });
        
        document.querySelector(".reset-channels-button").addEventListener("click",
            function () {
                this.className = Tv.helpers.replaceClass(this.classList, "red", "blue");
                Tv.helpers.saveCookie(collectionName, null, "delete");
                Tv.actions.toggleChannelSwitchBasedOnCookie();
                setTimeout(function() {
                        document.location.reload();
                    },
                    500);
            });

        document.querySelector(".toggle-channels-button").addEventListener("click",
            function() {
                var me = this;
                var state = me.getAttribute("data-toggle");
                var checkBoxes = document.querySelectorAll(".switch input");

                if (state === "on") {
                    me.setAttribute("data-toggle", "off");
                    me.innerText = "Markera alla";

                    [].forEach.call(checkBoxes,
                        function (checkbox) {
                        checkbox.checked = false;
                    });
                } else {
                    me.setAttribute("data-toggle", "on");
                    me.innerText = "Avmarkera alla";
                   [].forEach.call(checkBoxes,
                        function (checkbox) {
                        checkbox.checked = true;
                    });
                }
                Tv.actions.saveChannels(collectionName);
            });
        
    },

    showPage: function () {
        if (!Tv.helpers.resizeSingleShowIframe()) {
            return false;
        }

        if (Math.random() >= 1 / 6) {
            return;
        }

        var showContainer = document.querySelector(".show-container");
        var meta = document.querySelector(".meta");

        if (!showContainer || !meta) {
            return;
        }

        var showId = showContainer.dataset.showId;

        if (!showId) {
            return;
        }

        Tv.helpers.setIntersectionObserver(meta, function () {
            var postUrl = "/ajax/addstats?showId=" + encodeURIComponent(showId);
            Tv.helpers.makeRequest(postUrl, null, "POST", 1000);
        }, 100);
    },

    tmdbPage: function () {
        Tv.actions.initToggleActions();
        Tv.actions.showTrailer();
        Tv.helpers.setIntersectionObserver(document.querySelector("[data-event-observer]"), function () {
            Tv.helpers.getActorImages();
        },
        50);

        Tv.helpers.handleShowMoreText();

        var element = document.querySelector(".ad-traction");
        Tv.actions.insertAdtractionAd(element);
        Tv.movieNotifications.initMoviePage();
    },

    moviePage: function() {
        Tv.helpers.highlightMenuLink(3);
        Tv.actions.setUpWeekdayNavigation();


        var togglePreviousScheduleButton = document.querySelector(".toggle-previous");
        if (togglePreviousScheduleButton) {
            togglePreviousScheduleButton.addEventListener("click", function () {
                Tv.helpers.handleToggleOfPreviousShows(
                    this,
                    document.querySelectorAll(".schedule-tabla"),
                    false
                );
            });
        }
        Tv.helpers.initGenreFilter("[data-genre-list]", "[data-genre-list-controller] [data-genre]");

    },

    tvSeriesPage: function () {

        Tv.helpers.highlightMenuLink(5);
        Tv.actions.setUpWeekdayNavigation();

        Tv.helpers.handleShowMoreText();
        Tv.actions.initToggleActions();

        var togglePreviousScheduleButton = document.querySelector(".toggle-previous");
        if (togglePreviousScheduleButton) {
            togglePreviousScheduleButton.addEventListener("click", function () {
                Tv.helpers.handleToggleOfPreviousShows(
                    this,
                    document.querySelectorAll(".schedule-tabla"),
                    false
                );
            });
        }

        Tv.helpers.initGenreFilter("[data-genre-list]", "[data-genre-list-controller] [data-genre]");
       
    },

    allPages: function () {

        Tv.global.cookie = Tv.helpers.readCookie();

        document.querySelector(".action-load-channels").addEventListener("click", function (e) {
            e.preventDefault();
            Tv.actions.getChannelList();
        });

        // Searchbutton
        document.querySelector(".menu .search-button a").addEventListener("click", function (e) {
            e.preventDefault();
            Tv.autocomplete.init();
        });
        
        //MENU
        document.querySelector(".menu-button").addEventListener("click", function () {
            var menu = document.querySelector("ul.menu");
            var icon = this.querySelector("i");
            var isExpanded = menu.classList.toggle("expanded");

            icon.className = isExpanded ? "fa fa-close" : "fa fa-bars";
            this.setAttribute("aria-expanded", isExpanded);
            this.setAttribute("aria-label", isExpanded ? "Dölj menyn" : "Visa menyn");
        });

        Tv.helpers.showGdprMessage();
        Tv.helpers.trackPage();
        Tv.movieNotifications.check();
    },

    set: function() {
        this.allPages();
        var page = document.querySelector("body").getAttribute("data-page").split(" ")[0];
        switch (page) {
        case "start-pg":
            this.startPage();
                return;

        case "channel-pg":
            this.channelPage(2);
            return;

        case "toggle-pg":
            this.channelSettings();
            return;

        case "sort-pg":
            this.sortChannelsSettingsPage();
                return;

         case "sport-pg":
            this.channelPage(4);
            var elements = document.querySelectorAll(".ad-traction");
            var gad = document.querySelector("#b-0");
            var rows = document.querySelectorAll("tr.u");

            if (!rows || rows.length < 17) {
                elements.forEach(el => el.remove());
                return;
            }
            var random = Math.floor(Math.random() * (16 - 10 + 1)) + 10;
            var selected = rows[random];
            var parent = selected.parentNode;
            parent.insertBefore(gad, selected);
            elements.forEach(el => Tv.actions.insertAdtractionAd(el,"tv4-play-se-sport", false));

                return;

        case "genre-pg":
     
            var elements = document.querySelectorAll(".ad-traction");
            var gad = document.querySelector("#b-0");
            var rows = document.querySelectorAll("tr.u");

            if (!rows || rows.length < 17) {
                elements.forEach(el => el.remove());
                return;
            }
            var random = Math.floor(Math.random() * (16 - 10 + 1)) + 10;
            var selected = rows[random];
            var parent = selected.parentNode;
            parent.insertBefore(gad, selected);
            elements.forEach(el => Tv.actions.insertAdtractionAd(el, "random", true));


            const initGenreToggle = () => {
                const nav = document.querySelector('.genre-nav');
                if (!nav) return;

                const button = nav.querySelector('[data-genre-toggle]');
                if (!button) return;

                const hiddenItems = nav.querySelectorAll('.genre-nav__item.is-hidden');

                button.addEventListener('click', () => {
                    const isExpanded = button.getAttribute('aria-expanded') === 'true';
                    const nextExpanded = !isExpanded;

                    button.setAttribute('aria-expanded', String(nextExpanded));
                    button.textContent = nextExpanded ? 'Visa färre' : 'Visa fler';
                    button.setAttribute(
                        'aria-label',
                        nextExpanded ? 'Visa färre genrer' : 'Visa fler genrer'
                    );

                    hiddenItems.forEach(item => {
                        if (nextExpanded) {
                            item.removeAttribute('hidden');
                        } else {
                            item.setAttribute('hidden', '');
                        }
                    });
                });
            };

            initGenreToggle();
            return;

        case "show-pg":
            this.showPage();
            return;

        case "movie-pg":
                this.moviePage();
                Tv.helpers.handleShowMoreText();
                return;

        case "series-pg":
            this.tvSeriesPage();
                
            return;

            case "tmdb-pg":
            this.tmdbPage();
                return;

            case "streaming-pg":
                Tv.helpers.highlightMenuLink(6);

                var loadMoreButton = document.querySelector("#toggle-tv-shows");

                if (!loadMoreButton) {
                    return;
                }

                loadMoreButton.addEventListener("click", function (e) {
                    e.preventDefault();

                    var button = this;
                    var list = document.querySelector("#topratedstreamingtvshows");

                    if (!list) {
                        return;
                    }

                    button.disabled = true;
                    button.textContent = "Laddar...";

                    Tv.helpers.makeRequest(
                        "/ajax/load-imdb-more-shows/",
                        function (data) {
                            var template = document.createElement("template");
                            template.innerHTML = data.trim();

                            list.appendChild(template.content);

                            button.remove();
                        },
                        "GET",
                        6000
                    );
                });

                return;

        default:
            return;
        }
    }
};

document.addEventListener("DOMContentLoaded", function () {
    Tv.listners.set();
});
